export default ({ ...props }) => (
  <svg
    width="18"
    viewBox="0 0 40 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.00004 12.0001C8.2063 12.0001 10.0001 10.2063 10.0001 8.00003C10.0001 5.79376 8.2063 4 6.00004 4C3.79377 4 2.00001 5.79376 2.00001 8.00003C2.00001 10.2063 3.79377 12.0001 6.00004 12.0001ZM10.8188 15.1626C10.0938 14.4438 9.10006 14.0001 8.00005 14.0001H4.00003C1.79376 14.0001 0 15.7938 0 18.0001V20.0001C0 21.1064 0.893756 22.0001 2.00001 22.0001H6.11879C6.51254 19.0376 8.30005 16.5438 10.8188 15.1626Z"
      fill="currentcolor"
    />
    <path
      d="M20.0001 14.0001C23.8689 14.0001 27.0001 10.8688 27.0001 7.00005C27.0001 3.13127 23.8689 0 20.0001 0C16.1313 0 13 3.13127 13 7.00005C13 10.8688 16.1313 14.0001 20.0001 14.0001ZM24.8001 16.0001H24.2814C22.9813 16.6251 21.5376 17.0001 20.0001 17.0001C18.4626 17.0001 17.0251 16.6251 15.7188 16.0001H15.2C11.225 16.0001 8 19.2251 8 23.2002V25.0002C8 26.6564 9.34376 28.0002 11 28.0002H29.0001C30.6564 28.0002 32.0002 26.6564 32.0002 25.0002V23.2002C32.0002 19.2251 28.7751 16.0001 24.8001 16.0001Z"
      fill="currentcolor"
    />
    <path
      d="M34.0004 12.0001C36.2067 12.0001 38.0004 10.2063 38.0004 8.00003C38.0004 5.79376 36.2067 4 34.0004 4C31.7942 4 30.0004 5.79376 30.0004 8.00003C30.0004 10.2063 31.7942 12.0001 34.0004 12.0001ZM36.0004 14.0001H32.0004C30.9004 14.0001 29.9066 14.4438 29.1816 15.1626C31.7004 16.5438 33.4879 19.0376 33.8754 22.0001H38.0004C39.1067 22.0001 40.0005 21.1064 40.0005 20.0001V18.0001C40.0005 15.7938 38.2067 14.0001 36.0004 14.0001Z"
      fill="currentcolor"
    />
  </svg>
);
